import request from './common/request'
import qs from 'qs'

import { SIMBART_MERCHANT_ACTIVITY_CONFIG_GROUP_URL } from './urls'

// 列表
async function all () {
  return request(
    {
      url: SIMBART_MERCHANT_ACTIVITY_CONFIG_GROUP_URL,
      method: 'GET'
    }
  )
}

// 插入
async function insert (data) {
  return request(
    {
      url: SIMBART_MERCHANT_ACTIVITY_CONFIG_GROUP_URL,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

// 更新
async function update (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_GROUP_URL}/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

// 删除
async function remove (id) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_GROUP_URL}/${id}`,
      method: 'DELETE'
    }
  )
}

// 启用
async function enable (id) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_GROUP_URL}/${id}/enable`,
      method: 'PUT'
    }
  )
}

// 禁用
async function disable (id) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_GROUP_URL}/${id}/disable`,
      method: 'PUT'
    }
  )
}

export default {
  all,
  insert,
  update,
  remove,
  enable,
  disable
}



// WEBPACK FOOTER //
// ./src/api/merchant-simbart-activity-config-group.js